module.exports = "https://static.wmbcdn.com/uniweb/images/5f3c5f4ae076747d16cc648093ff00fa.svg";